import { Component, Input, OnInit } from '@angular/core'
import { LogService } from 'src/app/services/log/log.service'
import { ModalService } from 'src/app/services/modal/modal.service'
import { SignupService } from 'src/app/services/signup/signup.service'

/**
 * google, apple login modal
 */
@Component({
  selector: 'app-none-kakao-login-modal',
  templateUrl: './none-kakao-login-modal.component.html',
  styleUrls: ['./none-kakao-login-modal.component.scss'],
})
export class NoneKakaoLoginModalComponent implements OnInit {
  constructor(
    private modalService: ModalService,
    private signupService: SignupService,
    private logService: LogService
  ) {}

  @Input() state: string = location.pathname + location.search

  ngOnInit() {}

  onClickClose(): void {
    this.modalService.dismiss()
  }

  async onClickLogin(type: 'apple' | 'google'): Promise<void> {
    if (type === 'apple') {
      this.signupService.loginWithApple(this.state)
    } else {
      this.signupService.loginWithGoogle(this.state)
    }
  }
}
